import React from 'react'
import { Color, ColorPicker } from 'material-ui-color'
import { Box } from '@material-ui/core'
import { IInputProps } from 'src/types'
import StringInput from './StringInput'

const CustomColorInput = (props: IInputProps<string>): JSX.Element => {
  const { onChange, value } = props

  const handleColorPickerChange = (e: Color): void => {
    const color = typeof e.hex === 'string' ? `#${e.hex}` : e
    onChange(color)
  }

  return (
    <Box
      display='flex'
      alignItems='flex-end'
    >
      <ColorPicker
        value={value ?? undefined}
        onChange={handleColorPickerChange}
        hideTextfield
      />

      <StringInput
        {...props}
        onChange={onChange}
      />
    </Box>
  )
}

export default CustomColorInput
